import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAddOn, updateAddOn, retireAddOn } from '../services/smr-admin';
import type { AddOnPayload } from '../services/smr-admin';
import { addonKeys } from './useAddOnsQuery';

export function useAddOnMutations() {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries({ queryKey: addonKeys.all });

    return {
        createMutation: useMutation({
            mutationFn: (payload: AddOnPayload) => createAddOn(payload),
            onSuccess: invalidate,
        }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: Partial<AddOnPayload> }) => updateAddOn(id, payload),
            onSuccess: invalidate,
        }),
        retireMutation: useMutation({
            mutationFn: (id: string) => retireAddOn(id),
            onSuccess: invalidate,
        }),
    };
}
